import {BrowserRouter, Routes, Route } from "react-router-dom";
import { useContext } from "react";
import { AppMainContext } from "../context/AppMainContext";
import {ToastContainer, Bounce} from "react-toastify";
import SignIn from "../components/SignIn";
import SignUp from "../components/SignUp";
import Loading from "../components/Loading";
import MyTasks from "../components/MyTasks";
import History from "../components/History";

export default function AppRouter() {
    const { currentUser, isLoading } = useContext(AppMainContext);
    return (
        isLoading ? <Loading/> : 
            <BrowserRouter>
                <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick={true} rtl pauseOnFocusLoss={false} draggable pauseOnHover theme="dark" transition={Bounce}/>
                <Routes>
                    <Route path='/' element={<SignIn/>}/>
                    <Route path='/signup' element={<SignUp/>}/>
                    <Route path={`/${currentUser?.id}/myTasks`} element={<MyTasks/>}/>
                    <Route path={`/${currentUser?.id}/history`} element={<History/>}/>
                </Routes>
            </BrowserRouter>
    )
}
